import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useRouter } from '@src/routes'
import { Grid, Container, Theme, Typography } from '@material-ui/core'
import SimpleLayout, {
  LayoutSpacingOptions,
} from '@src/components/SimpleLayout'
import ForgotPasswordForm from './ForgotPasswordForm'
import { FormattedMessage } from 'react-intl'
import messages from '@utils/messages'
import GlobalAlert from '@src/components/GlobalAlert'

const useStyles = makeStyles((theme: Theme) => ({
  vr2: {
    marginBottom: theme.spacing(2),
  },
  vr4: {
    marginBottom: theme.spacing(4),
  },
  vr8: {
    marginBottom: theme.spacing(8),
  },
}))

const ForgotPassword = () => {
  const router = useRouter()
  const classes = useStyles()
  const [variables, setVariables] = useState({
    showUserName: false,
    showSuccessMsg: false,
  })
  const [errorMsg, setErrorMsg] = useState('')
  let passwordExpiredUser = false
  if (router.query && router.query.passwordExpired) passwordExpiredUser = true // User's password expired
  const titleMsg = variables.showSuccessMsg
    ? messages.RESET_PASSWORD_LINK_SENT
    : messages.FORGOT_PASSWORD_HEAD
  //Refer to STRAT-11639
  const hasBodyMessage = !variables.showSuccessMsg
  let bodyMsg

  if (hasBodyMessage && !variables.showSuccessMsg) {
    bodyMsg = messages.RESET_PASSWORD_REQUEST_MESSAGE
  }

  if (!router?.query) return null

  const shouldShowErrorMsg = errorMsg.length > 0

  return (
    <SimpleLayout spacing={LayoutSpacingOptions.MD}>
      <Container maxWidth="lg">
        <Grid container>
          {/* Marketing Content */}
          <Grid item xs={12} sm={9} md={6}>
            {shouldShowErrorMsg && (
              <GlobalAlert severity="error" className={classes.vr4}>
                {errorMsg}
              </GlobalAlert>
            )}

            {passwordExpiredUser && (
              <GlobalAlert severity="error" className={classes.vr4}>
                <FormattedMessage
                  {...messages.FORGOT_PASSWORD_PASSWORD_EXPIRED}
                />
              </GlobalAlert>
            )}

            <Typography variant="h1" className={classes.vr2}>
              <FormattedMessage {...titleMsg} />
            </Typography>

            {hasBodyMessage && (
              <Typography component="p" variant="body2" className={classes.vr8}>
                <FormattedMessage {...bodyMsg} />
              </Typography>
            )}

            {/* ForgotPassword Form */}
            <ForgotPasswordForm
              variables={variables}
              setVariables={setVariables}
              setErrorMsg={setErrorMsg}
            />
          </Grid>
        </Grid>
      </Container>
    </SimpleLayout>
  )
}

export default ForgotPassword
